import { createFeatureSelector, createSelector } from '@ngrx/store'
import { Role, RoleDetailState, RoleState } from './role-permission.state'
import { selectRole } from './role-permission.reducer'

export const selectRoleState = createFeatureSelector<RoleState>('role')

// Selector to get the total count of businesses
// export const selectTotalCount = createSelector(selectRoleState, (state: RoleState) => {
//   // console.log('RoleState:', state)
//   return state.totalCount
// })

// Select the feature state

// Select the feature state
export const selectRoleDetailState = createFeatureSelector<RoleDetailState>('roleDetail')
export const selectRoleDetail = createSelector(selectRole, state => {
  // console.log('selector state', state)
  return state || ({} as Role)
})

export const selectRoleDetailError = createSelector(
  selectRoleDetailState,
  (state: RoleDetailState) => state.error
)
